import React from 'react';
import './Testimonials.css';

const testimonials = [
  {
    name: 'Marie L.',
    region: 'Lyon, France',
    date: 'Novembre 2024',
    amount: '−87,97€',
    text: 'J\'ai commandé un tapis de course à 29,99€ sur TikTok. J\'ai validé mon paiement et je me suis retrouvée sur un site bizarre. En 4 jours, trois prélèvements différents sur mon compte : 29,99€, 9,99€ et 47,99€. Le tapis n\'est jamais arrivé. J\'ai dû appeler ma banque en urgence.',
    product: 'Tapis de course',
  },
  {
    name: 'Thomas R.',
    region: 'Paris, France',
    date: 'Octobre 2024',
    amount: '−139€',
    text: 'Abonnement activé sans que je comprenne comment. Ils prélevaient 49€ par mois. Quand j\'ai enfin trouvé le lien de résiliation (caché dans les CGV), ça faisait 3 mois qu\'ils me saignaient. Zéro produit reçu. Dépôt de plainte effectué.',
    product: 'Aspirateur robot',
  },
  {
    name: 'Camille D.',
    region: 'Bordeaux, France',
    date: 'Décembre 2024',
    amount: '−62€',
    text: 'Ma mère de 68 ans s\'est fait avoir. Elle ne comprend pas ce qui s\'est passé — elle a cliqué sur une pub pour une lampe chauffante à 19€ et ils lui ont pris plus de 60€ en 2 fois. Le service client ne répond qu\'en anglais avec des réponses automatiques.',
    product: 'Lampe chauffante',
  },
  {
    name: 'Julien M.',
    region: 'Strasbourg, France',
    date: 'Janvier 2025',
    amount: '−94,98€',
    text: 'Piégé via une pub TikTok pour des écouteurs à 24,99€. Immédiatement après paiement, redirection vers jumpvendor.com. J\'ai reçu une confirmation de commande mais jamais le produit. Deux prélèvements supplémentaires les jours suivants pour "livraison express" et "garantie premium" que je n\'avais pas demandés.',
    product: 'Écouteurs Bluetooth',
  },
  {
    name: 'Sophie B.',
    region: 'Marseille, France',
    date: 'Février 2025',
    amount: '−77€',
    text: 'J\'ai remarqué le changement d\'URL trop tard, après avoir tapé mon numéro de carte. En quelques jours : 3 prélèvements. Rétrofacturation obtenue auprès de ma banque après 3 semaines. Ce site est un danger public.',
    product: 'Montre connectée',
  },
];

export default function Testimonials() {
  return (
    <section className="testimonials section" id="temoignages" aria-labelledby="test-title">
      <div className="container">
        <span className="tag orange">Victimes témoignent</span>
        <h2 id="test-title" className="section-title" style={{ color: 'white' }}>
          Ils Ont Été Piégés — <span style={{ color: 'var(--red-bright)' }}>Lisez Leurs Témoignages</span>
        </h2>
        <p className="section-subtitle">
          Ces témoignages réels montrent que vous n'êtes pas seul(e). Même système, mêmes méthodes, mêmes victimes.
        </p>

        <div className="testimonials__grid">
          {testimonials.map((t, i) => (
            <article key={i} className="testimonial-card" aria-label={`Témoignage de ${t.name}`}>
              <div className="testimonial-card__header">
                <div className="testimonial-card__avatar" aria-hidden="true">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <div className="testimonial-card__name">{t.name}</div>
                  <div className="testimonial-card__meta">{t.region} · {t.date}</div>
                </div>
                <div className="testimonial-card__amount">{t.amount}</div>
              </div>

              <div className="testimonial-card__product">
                🛒 Commande initiale : <strong>{t.product}</strong>
              </div>

              <blockquote className="testimonial-card__text">
                "{t.text}"
              </blockquote>

              <div className="testimonial-card__footer">
                <span className="testimonial-card__verified">✓ Témoignage vérifié</span>
              </div>
            </article>
          ))}
        </div>

        <div className="testimonials__cta">
          <p>Vous avez vécu la même chose ?</p>
          <a href="#signaler" className="testimonials__cta-btn">
            📢 Ajouter votre témoignage
          </a>
        </div>
      </div>
    </section>
  );
}
